import { render, staticRenderFns } from "./VAddProjectMilestoneForm.vue?vue&type=template&id=3b13f90c&"
import script from "./VAddProjectMilestoneForm.vue?vue&type=script&lang=js&"
export * from "./VAddProjectMilestoneForm.vue?vue&type=script&lang=js&"
import style0 from "./VAddProjectMilestoneForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports